class CartItems extends HTMLElement {
  constructor() {
    super();

    //add event listeners
    this.addListeners();
    this.drawer = this.closest(".drawer--mini-cart");
    this.cartSection = this.closest(".cart-section");
    this.miniCartToggles = document.querySelectorAll(".js-mini-cart-toggle");
    this.cartItemCount = this.getAttribute("data-cart-item-count");
    this.cartItemCountEl = document.querySelector("p[data-cart-items]");
    this.cartIcon = this.cartItemCountEl.previousElementSibling.querySelector(
      "svg.icon--bag g path:first-child"
    );
  }

  cartAddUnsubscriber = undefined;
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    if (this.cartItemCount > 0) {
      this.cartItemCountEl.textContent = this.cartItemCount;
      this.cartIcon.classList.add("cart-item-count-active");
    } else {
      this.cartIcon.classList.remove("cart-item-count-active");
    }

    this.cartAddUnsubscriber = subscribe(PUB_SUB_EVENTS.cartAdd, () => {
      this.renderCart();
      if (this.drawer && !this.drawer.classList.contains("active")) {
        this.drawer.dispatchEvent(new Event("drawer-toggle"));
      }
    });

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.renderCart();
    });
  }

  disconnectedCallback() {
    if (this.cartAddUnsubscriber) {
      this.cartAddUnsubscriber();
    }

    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  //quantity input change
  handleInputChange(input, keys) {
    if (this.drawer) {
      this.drawer.classList.add("loading");
    } else if (this.cartSection) {
      this.cartSection.classList.add("loading");
    }

    let quantity = 0;

    if (input && input.value) {
      quantity = parseInt(input.value);
    }

    const itemsToUpdate = [];

    keys.forEach((key) => {
      itemsToUpdate.push({
        key: key,
        quantity: quantity,
      });
    });

    if (itemsToUpdate && quantity >= 0) {
      const sectionToGet = this.drawer ? "mini-cart" : "cart";

      const body = JSON.stringify({
        updates: itemsToUpdate.reduce((updates, item) => {
          updates[item.key] = item.quantity;
          return updates;
        }, {}),
        sections: [sectionToGet]
      })

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          let sectionHtml = this.drawer
            ? JSON.parse(text).sections["mini-cart"]
            : JSON.parse(text).sections["cart"];
          this.renderCart(sectionHtml);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      this.drawer.classList.remove("loading");
      console.error("No line item details");
    }
  }

  renderCart(html) {
    if (this.drawer) {
      this.drawer.classList.add("loading");
    } else if (this.cartSection) {
      this.cartSection.classList.add("loading");
    }

    if (html) {
      const htmlParsed = new DOMParser().parseFromString(html, "text/html");
      const cartItemsCount = htmlParsed
        .querySelector("[data-cart-item-count]")
        .getAttribute("data-cart-item-count");

      if (this.cartItemCountEl && cartItemsCount !== "0") {
        this.cartItemCountEl.textContent = cartItemsCount;
      } else {
        this.cartItemCountEl.textContent = "";
        this.cartIcon.classList.remove("cart-item-count-active");
      }

      //insert cart items
      if (this.drawer) {
        document.querySelector(".js-mini-cart").innerHTML = html;
        this.refreshMentionMe();
      } else {
        const htmlParsed = new DOMParser().parseFromString(html, "text/html");
        document.querySelector(".js-cart-section").innerHTML =
          htmlParsed.querySelector(".js-cart-section").innerHTML;
      }

      this.postRenderFunctions();
    } else {
      const sectionToGet = this.drawer ? "mini-cart" : "cart";

      fetch(window.routes.root_url + `?section_id=${sectionToGet}`)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          //insert cart items
          if (this.drawer) {
            document.querySelector(".js-mini-cart").innerHTML = response;
            this.refreshMentionMe();
          } else {
            const html = new DOMParser().parseFromString(response, "text/html");

            document.querySelector(".js-cart-section").innerHTML =
              html.querySelector(".js-cart-section").innerHTML;
          }

          this.postRenderFunctions();
        });
    }
  }

  postRenderFunctions() {
    //add event listeners
    this.addListeners();

    //remove loading
    if (this.drawer) {
      this.drawer.classList.remove("loading");
    } else if (this.cartSection) {
      this.cartSection.classList.remove("loading");

      this.refreshRecommendations();
    }
  }

  addListeners() {
    //get form elements and add event listeners
    this.cartForm = this.closest("form");
    if (this.cartForm) {
      this.quantityInputs = this.cartForm.querySelectorAll(".js-cart-quantity");
      this.removeButtons = this.cartForm.querySelectorAll(".js-cart-remove");
      if (this.quantityInputs) {
        this.quantityInputs.forEach((input) =>
          input.addEventListener("change", () => {
            const keysToUpdate = this.addLinkedProductKeys(input);
            this.handleInputChange(input, keysToUpdate);
          })
        );
      }

      if (this.removeButtons) {
        this.removeButtons.forEach((input) =>
          input.addEventListener("click", (e) => {
            e.preventDefault();            
            const keysToUpdate = this.addLinkedProductKeys(input);
            this.handleInputChange(null, keysToUpdate);
          })
        );
      }
    }
  }

  addLinkedProductKeys(input) {
    const productKeys = [input.getAttribute("data-key")];

    if (input.getAttribute("data-linked")) {
      const linkedKeys = input.getAttribute("data-linked").split(",");
      linkedKeys.forEach((key) => {
        productKeys.push(key);
      });
    }

    return productKeys;
  }

  refreshRecommendations() {
    //if cart page has recommendations
    if (
      document.querySelector(".js-cart-recommendations") &&
      document.querySelector(".js-cart-recommendations product-recommendations")
    ) {
      fetch(
        window.routes.root_url + `?section_id=product-recommendations-slides`
      )
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const html = new DOMParser().parseFromString(response, "text/html");

          document.querySelector(
            ".js-cart-recommendations product-recommendations"
          ).outerHTML = html.querySelector("product-recommendations").outerHTML;
        });
    }
  }

  refreshMentionMe() {
    let cartHtml = document.querySelector(".js-mini-cart");

    const mentionMeScript = `
    // Enter your Mention Me partner code here:
    var partnerCode = "mme0a01051";

    var situation = 'sidecart'; 
    var implementation = 'link';
    // This will ensure the implementation (link) and situation (sidecart) get
    // cleared before loading the Mention Me tag shown on refresh or page change. 
    if (window.MentionMeFiredTags != undefined && window.MentionMeFiredTags != '') { 
      if (window.MentionMeFiredTags[implementation + situation] == true) { 
          delete window.MentionMeFiredTags[implementation + situation] 
      } 
    }

    var urlComponents = [
      "https://tag.mention-me.com/api/v2/refereefind/",
      partnerCode
    ];

    var queryComponents = [
      ["situation", situation],
      // Locale
      ["locale", Shopify.locale + "_" + Shopify.country],
    ];

    queryComponents = queryComponents.map((qc) => qc[0] + "=" + encodeURIComponent(qc[1]));

    var url = urlComponents.join("") + "?" + queryComponents.join("&");

    var script = document.createElement("script");
    script.src = url;

    document.getElementsByTagName("head")[0].appendChild(script);
    `;

    const mentionMeElement = `
    <div id="mmWrappercart"></div>
    `;

    let script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = mentionMeScript;

    cartHtml.querySelector(".mini-cart").append(script);
    cartHtml
      .querySelector(".mini-cart")
      .insertAdjacentHTML("afterbegin", mentionMeElement);
  }
}

customElements.define("cart-items", CartItems);
